import utils from "Sources/utils/utils";
//import NavUtils from "Sources/utils/navigation-utils";
const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/missions/mission-toggle.html";

import "Styles/components/mission-label.scss";

class MissionToggle
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.hasRendered = false;
    this.mission = options.mission;
    this.onMissionClicked = options.onMissionClicked;
    this.onCopyMission = options.onCopyMission;
    this.onDeleteMission = options.onDeleteMission;
    this.selected = false;
    this.blocked = false;
    this.checkbox = options.checkbox;
  }

  get mission()
  {
    return this._mission;
  }

  set mission(mission)
  {
    this._mission = mission;
    this.updateMissionToggle();
  }

  static setUpMissionToggle(options)
  {
    let instance = new MissionToggle(options);
    instance.render();

    if(options.hideButtons)
    {
      instance.hideButtons();
    }

    if(options.clickable)
    {
      instance.setUpEventListeners();
    }

    if(options.checkbox)
    {
      //instance.showCheckbox();
    }

    instance.setUpMissionIcon();


    return instance;
  }

  setUpMissionIcon()
  {
    switch(this.mission.source)
    {
      case "standard_mission":
        this.$element.find(".icn_mission_cartamundi").show();
        break;

      case "school_shared":
        this.$element.find(".icn_school").show();
        break;

      case "user_shared":
        this.$element.find(".icn_user").show();
        break;

      case "owner":
        this.$element.find(".icn_user").show();
        break;

      case null:
        this.$element.find(".icn_mission_cartamundi").show();
        break;

      default:
        this.$element.find(".icn_user").show();
        break;
    }
  }

  setUpEventListeners()
  {

    const COPY_BTN = ".copy-mission-btn";
    const DELETE_BTN = ".delete-mission-btn";

    let that = this;
    this.$element.on("click", function(e)
    {
      that.missionClicked();
    });

    this.$element.find(COPY_BTN).on("click", function(e)
    {
      e.stopPropagation();
      that.copyMission();
    });

    this.$element.find(DELETE_BTN).on("click", function(e)
    {
      e.stopPropagation();
      that.deleteMission();
    });

    this.$element.on("dragstart", function(e)
    {
      //e.preventDefault();
      e.stopPropagation();
      that.onMissionDrag(e);
    });
  }

  onMissionDrag(e)
  {
    e.dataTransfer.setData("mission/id", this.mission.key);
    e.dataTransfer.effectAllowed = "copy";
  }

  missionClicked()
  {
    if(!this.blocked)
    {
      this.toggleSelected();
      this.onMissionClicked(this);
    }
  }

  toggleSelected()
  {
    if(this.$element.hasClass("selected"))
    {
      this.selected = false;
      this.$element.removeClass("selected");
    }
    else
    {
      this.selected = true;
      this.$element.addClass("selected");
    }
  }

  setBlocked()
  {
    this.blocked = true;
    this.selected = false;
    this.$element.removeClass("selected");
    this.$element.addClass("blocked");
  }

  setUnblocked()
  {
    this.blocked = false;
    this.$element.removeClass("blocked");
  }

  setUnselected()
  {
    this.selected = false;
    this.$element.removeClass("selected");
  }

  hideButtons()
  {
    this.$element.find(".copy-mission-btn").hide();
    this.$element.find(".delete-mission-btn").hide();
  }

  copyMission()
  {
    this.onCopyMission(this.mission);
  }

  deleteMission()
  {
    //TODO: remove mission from potential group
    this.onDeleteMission(this);
    this.destroy();
  }

  render()
  {
    this.hasRendered = false;
    this.$element = $(HtmlTemplate);
    this.$container.append(this.$element);
    LanguageManager.applyLocale(this.$element);

    this.updateMissionToggle();
    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  updateMissionToggle() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      let $missionName = this.$element.find("[data-bind-target='mission-label-name']");
      $missionName.empty();

      if (utils.isNotNull(this.mission) && utils.isNotNull(this.mission.name)) {
        $missionName.text(this.mission.name);
      }

      if(this.checkbox)
      {
        let $checkbox = this.$element.find(".checkbox");
        $checkbox.show();
      }
      else
      {
        let $checkbox = this.$element.find(".checkbox");
        $checkbox.hide();
      }

    }
  }

}

export default MissionToggle;



// WEBPACK FOOTER //
// ./app/js/components/mission-toggle.js